export default __webpack_public_path__ + "static/media/product3.4de806a7.png";